import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import Remittance from "./Remittance";
import GridConfig from "./GridConfig";

export default class Remittances extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'remittance',
            data: null,
            loading: true,
            configName: 'remittances_grid',
            moduleName: 'حواله ها',
            ids: [],
            filters: {
                io: props.IO,
            }
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    componentWillReceiveProps(props) {
        if (props.IO == this.state.filters.io) return;
        this.state.filters.io = props.IO;
        this.refreshData();
    }
    getCaptions() {
        if (this.state.filters.io == 1) return "رسیدها";
        if (this.state.filters.io == 2) return "حواله ها";
    }
    getCaption() {
        if (this.state.filters.io == 1) return "رسید";
        if (this.state.filters.io == 2) return "حواله";
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Remittance IO={this.state.filters.io} Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Remittance IO={this.state.filters.io} Caller={this} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "number", caption: "شماره", show: true },
                { field: "warehouseName", caption: "انبار", show: true },
                { field: "description", caption: "شرح", show: true },
                { field: "typeString", caption: "نوع", show: true },
                { field: "dateString", caption: "تاریخ", show: true },
                { field: "editDateString", caption: "تاریخ ثبت", show: false },
                { field: "createDateString", caption: "تاریخ بروزرسانی", show: false }
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'number' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.number}</a> } });
            if (f.field == 'warehouseName' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'description' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'typeString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'dateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'editDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'createDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        return t;
    }
    renderForm() {
        return <div className="container">
            {this.getToolBar(false)}
            {this.renderAgGrid({
                columnDefs: this.getColumns()
            })}
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                this.renderForm(),
                this.renderPopupComponent(),
                <Footer />
            ];
        return contents;
    }
}